































import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import dayjs from "dayjs";
@Component({
    components: {
      
    },
})
export default class calendarPanel extends Vue {
    public $refs: {
    };

    @Prop({
        default:false
    })
    show:Boolean;

    @Prop({
        default:new Date(new Date().getFullYear() - 1, 0, 1)
    })
    minDate:Date;
    @Prop({
        default:new Date(new Date().getFullYear() , new Date().getMonth(), new Date().getDate())
    })
    maxDate:Date;
    @Prop({
        default:false
    })
    isPopup:Boolean;
    @Prop({
        default:[new Date(), new Date()]
    })
    defaultDate:Array<any>;
    created() {
    }
    mounted() {
        
    }

    onselConfirm(date){
        this.$emit('onselConfirm',date)
    }
    closeFun(){
        this.$emit('closeFun')
    }
    cbFun(){}
    resetTime(){
        this.$refs['calendar'].reset();
    }
    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/components/pad/calendarPanel.vue